exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-archive[data-v-0fcdba91]{background:none;border:none}.btn-archive i[data-v-0fcdba91]{padding-top:5px;font-size:21px !important}", ""]);

// exports
